import { useContext } from 'react';
import { MouseEventsContext } from './MouseEventsContext';

export const useMouseEvents = () => {
  const context = useContext(MouseEventsContext);
  if (context === null) {
    throw new Error('useMouseEvents must be used within a MouseEventsProvider');
  }
  return context;
};
